import { createAction, props } from "@ngrx/store"

export const SHOW_ALERT='[app]show alert'
export const EMPTY_ACTION='[app]empty'


export const showalert=createAction(SHOW_ALERT,props<{severity:string,summary:string,detail:string}>())
export const emptyaction=createAction(EMPTY_ACTION)


export const showSpinner = createAction('[Spinner] Show Spinner');
export const hideSpinner = createAction('[Spinner] Hide Spinner');


const ON_SHOW_WARNING = '[Warning] Show Warning'
const ON_HIDE_WARNING = '[Warning] hide Warning'

export const showWarning = createAction(ON_SHOW_WARNING, props<{ key: string; summary: string; detail: string; severity: string; sticky: boolean }>());
export const hideWarning = createAction(ON_HIDE_WARNING);